import { getBase64Image } from '../server/interfaces'

export const getBase64Img = async imgUrl => {
  if (!imgUrl) {
    const errMsg = '请传入正确的图片链接'
    return Promise.reject(errMsg)
  }
  const data = await getBase64Image(imgUrl)
  return `data:image/png;base64,${data}`
}

export const getBase64ImgArr = (imgArr = []) => {
  const promiseArr = imgArr.map(imgUrl => getBase64Img(imgUrl))
  return Promise.all(promiseArr)
}
